<template>
    <div id="editar-minuta-acuerdo">
    <v-form v-model="formularioValido" ref="editarMinutaParticipantes">
        <v-card flat>
            <v-card-title class="secondary--text mb-4">
            Editar Participante
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-subtitle>
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col>
                  <custom-text-field
                  cols="12"
                  class=""
                  v-model="participante.nombre"
                  label="Nombre"
                  >
                  </custom-text-field>
                  <custom-text-field
                  cols="12"
                  class=""
                  v-model="participante.puesto"
                  label="Puesto"
                  >
                  </custom-text-field>
                  <custom-select
                  v-model="participante.tipo"
                  label="Tipo"
                  :items="tipoParticipantesLista"
                  item-text="nombre"
                  item-value="tipo"
                  return-value="tipo"
                  >
                  </custom-select>
                  <v-checkbox
                  v-model="participante.recurrente"
                  :value="participante.recurrente"
                  :true-value="1"
                  :false-value="0"
                  label="Recurrente"
                  color="secondary"
                  hide-details
                  class="my-0 mx-2 pl-2 text-subtitle-2">
                </v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
        </v-card>
    </v-form>

    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import mixParticipantes from './mixParticipantes';

export default {
  name: 'EditarMinutaParticipantes',
  mixins: [mixParticipantes],
  props: {
    participanteEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tipoParticipantesLista: [
        {
          tipo: 1,
          nombre: 'DEPENDENCIA',
        },
        {
          tipo: 2,
          nombre: 'CONTRATISTA',
        },
        {
          tipo: 3,
          nombre: 'SUPERVISION EXTERNA',
        },
        {
          tipo: 4,
          nombre: 'OTROS',
        },

      ],
      participantesSeleccionados: [],
      participantesGuardar: [],
      participante: {
        tipo: this.participanteEditar.tipo,
        nombre: this.participanteEditar.nombre,
        puesto: this.participanteEditar.puesto,
        recurrente: this.participanteEditar.recurrente,
      },
      participantesLista: [],
    };
  },
  components: {
    CustomButton,
    CustomTextField,
    CustomSelect,
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarMinutaParticipantes.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    async guardar() {
      await this.mixEditarParticipante();
    },
  },
};
</script>
